import { ToastContainer } from "react-toastify";
import Header from "../Components/Header";
import Status from "../Components/Status";
import Sheet from "../Components/Sheet";
import Footer from "../Components/Footer";
import { Mode } from "../App";



export const CalcPage = () => {
  return (
    <>
      <ToastContainer />
      <Header />
      <Status mode={Mode.CALCULATOR} />
      <Sheet mode={Mode.CALCULATOR} />
      <Footer />
    </>
  )
}
